// The marketing site (device.io) appends the visitor's anonymous PostHog
// distinct ID to links into the app, because cookies don't cross domains.
// PostHog adopts it at init through `bootstrap`, so the visitor stays one
// anonymous person until `identify` merges them at signup.

export const INBOUND_ID_PARAM = "__ph_distinct_id";

// The ID to bootstrap PostHog with, or null. A logged-in user already has an
// identity that an inbound ID must not replace.
export function inboundDistinctId(search, loggedIn) {
  if (loggedIn) return null;
  return new URLSearchParams(search).get(INBOUND_ID_PARAM) || null;
}

// The URL without the param, relative, for `history.replaceState`, or null when
// it is absent.
export function withoutInboundId({ pathname, search, hash }) {
  const params = new URLSearchParams(search);
  if (!params.has(INBOUND_ID_PARAM)) return null;

  params.delete(INBOUND_ID_PARAM);
  const query = params.toString();
  return `${pathname}${query ? `?${query}` : ""}${hash}`;
}

// The PostHog init option that adopts the inbound ID, or an empty object.
export function inboundBootstrap(search, loggedIn) {
  const distinctID = inboundDistinctId(search, loggedIn);
  return distinctID ? { bootstrap: { distinctID } } : {};
}

// Removes the param from the address bar without adding a history entry.
export function stripInboundId(location, history) {
  const cleanUrl = withoutInboundId(location);
  if (cleanUrl) history.replaceState(history.state, "", cleanUrl);
}
